/**
 * Created by mac on 4/8/18
 */

const RewardedAdsManager = function () {
    this.baseWatchCounter = 0;
    this.totalWatchCounter = cleverapps.dataLoader.load(DataLoader.TYPES.AD_WATCH_COUNTER) || 0;
    this.lastAdStarter = undefined;

    connector.ads.on("changeStatus", this.onChangePluginStatus.bind(this));

    connector.ads.on("rewarded:impression", this.onRewardedImpression.bind(this));
    connector.ads.on("interstitial:impression", this.onInterstitialImpression.bind(this));

    connector.ads.on("applovin:displayed", this.onApplovinDisplayed.bind(this));

    connector.ads.on("rewarded:loading", this.createLoadingOverlay.bind(this));
    connector.ads.on("interstitial:loading", this.createLoadingOverlay.bind(this));

    connector.ads.on("rewarded:loaded", this.removeLoadingOverlay.bind(this));
    connector.ads.on("interstitial:loaded", this.removeLoadingOverlay.bind(this));

    connector.ads.on("rewarded:start", this.createAdOverlay.bind(this, "rewarded"));
    connector.ads.on("interstitial:start", this.createAdOverlay.bind(this, "interstitial"));

    connector.ads.on("rewarded:close", this.removeAdOverlay.bind(this));
    connector.ads.on("interstitial:close", this.removeAdOverlay.bind(this));

    connector.ads.on("rewarded:reward", this.onReward.bind(this));

    connector.ads.on("rewarded:caching", (plugin) => {
        this.logAdCaching("rewarded", plugin);
    });
    connector.ads.on("interstitial:caching", (plugin) => {
        this.logAdCaching("interstitial", plugin);
    });

    connector.ads.on("rewarded:cached", this.onRewardedCached.bind(this));
    connector.ads.on("interstitial:cached", this.onInterstitialCached.bind(this));

    connector.ads.on("rewarded:start", (plugin) => {
        this.logAdStarted("rewarded", plugin);
    });
    connector.ads.on("interstitial:start", (plugin) => {
        this.logAdStarted("interstitial", plugin);
    });

    connector.ads.on("rewarded:close", (success) => {
        if (success) {
            this.logRewardedClosed();
        }
    });

    connector.ads.on("error:showRewarded", this.onRewardedError.bind(this));

    const frozenAd = cleverapps.dataLoader.load(DataLoader.TYPES.AD_FROZEN);
    if (frozenAd) {
        cleverapps.dataLoader.remove(DataLoader.TYPES.AD_FROZEN);
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.AD_FROZEN + frozenAd.networkName);
    }
};

RewardedAdsManager.prototype.onInterstitialCached = function (code, plugin) {
    if (code === connector.CODE_SUCCEED) {
        this.logAdCached("interstitial", plugin);
    } else {
        this.logAdLoadError(cleverapps.EVENTS.ADS.LOAD_ERROR_INTERSTITIAL, code, plugin);
    }
};

RewardedAdsManager.prototype.onRewardedCached = function (code, plugin) {
    if (code === connector.CODE_SUCCEED) {
        this.logAdCached("rewarded", plugin);

        this.logRewardedCached();
    } else {
        this.logAdLoadError(cleverapps.EVENTS.ADS.LOAD_ERROR_REWARDED, code, plugin);
    }
};

RewardedAdsManager.prototype.logAdLoadError = function (name, code, plugin) {
    if (code === "ads_loading_already_loading") {
        return;
    }
    cleverapps.metrics.logEvent(name, {
        plugin: plugin || "",
        error: String(code || "timeout").replace("ads_loading_", "")
    });
};

RewardedAdsManager.prototype.onRewardedError = function (code) {
    if (!RewardedAdsManager.ERROR_WINDOWS[code]) {
        cleverapps.notification.create(Messages.get(`AdError.${code}`));
    }

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.REWARDED_ERROR_DAU);
};

RewardedAdsManager.prototype.logRewardedClosed = function () {
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.REWARDED_DAU);
    cleverapps.playSession.logEvent(cleverapps.EVENTS.ADS.SESSION_FINISH_REWARDED);

    cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.ADS.FINISH);
};

RewardedAdsManager.prototype.logAdStarted = function (type) {
    if (type === "interstitial") {
        cleverapps.eventBus.trigger("taskEvent", "WATCH_ADS");
    }
};

RewardedAdsManager.prototype.logRewardedCached = function () {
    if (this.noadsTimeout) {
        clearTimeout(this.noadsTimeout);
        delete this.noadsTimeout;
    }

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.REWARDED_LOADED_DAU);
};

RewardedAdsManager.prototype.logAdCached = function (type, plugin) {
    plugin = plugin || "";
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.ADS.READY}_${type}_${plugin}`);
};

RewardedAdsManager.prototype.logAdCaching = function (type, plugin) {
    plugin = plugin || "";
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.ADS.CACHE}_${type}_${plugin}`);
};

RewardedAdsManager.prototype.onChangePluginStatus = function (status) {
    if (status === connector.STATUS_CONNECTED) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.REWARDED_AVAILABLE_DAU);

        clearTimeout(this.noadsTimeout);

        this.noadsTimeout = new cleverapps.LongTimeout((() => {
            cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.REWARDED_NOADS_DAU);
        }), cleverapps.parseInterval(RewardedAdsManager.REWARDED_NOADS_TIMEOUT));

        if (connector.ads.oneOf(connector.CLEVERAPPS_GOOGLE_ADS, connector.TEST)) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.ADS.CONNECTED}_${connector.ads.getName()}`);
        }
    }
};

RewardedAdsManager.prototype.onRewardedImpression = function (impressionCost) {
    this.logImpressionCost(impressionCost);

    cleverapps.kpi.logAdRevenue(impressionCost);

    cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.ADS.COST, { value: impressionCost });

    if (!this.lastAdStarter && cleverapps.config.debugMode) {
        throw "No ad starter placement defined!";
    }

    cleverapps.metrics.logEvent(connector.EVENTS.ADS.TYPE_COST + this.lastAdStarter, { value: impressionCost });
};

RewardedAdsManager.prototype.onInterstitialImpression = function (impressionCost) {
    this.logImpressionCost(impressionCost);

    cleverapps.kpi.logAdRevenue(impressionCost);

    cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.ADS.COST, { value: impressionCost });

    if (!this.lastAdStarter && cleverapps.config.debugMode) {
        throw "No ad starter placement defined!";
    }

    cleverapps.metrics.logEvent(connector.EVENTS.ADS.TYPE_COST + this.lastAdStarter, { value: impressionCost });

    connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.AD_IMPRESSION);
};

RewardedAdsManager.prototype.logImpressionCost = function (impressionCost) {
    if (connector.ads.oneOf(connector.AD_MOB)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.ADMOB_ADS, { value: impressionCost });
    } else if (connector.ads.oneOf(connector.APP_LOVIN)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.APP_LOVIN_ADS, { value: impressionCost });
    } else if (connector.ads.oneOf(connector.YANDEX_APP_ADS)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.YANDEX_APP_ADS, { value: impressionCost });
    }
};

RewardedAdsManager.prototype.onApplovinDisplayed = function (name, adInfo) {
    if (connector.ads.oneOf(connector.APP_LOVIN)) {
        cleverapps.dataLoader.save(DataLoader.TYPES.AD_FROZEN, {
            networkName: adInfo.networkName
        });
    }
};

RewardedAdsManager.prototype.onRewardedRefresh = function (callback, target) {
    const handler = connector.ads.on("rewarded:refresh", callback);

    addCleaner(target, handler.clear);
};

RewardedAdsManager.prototype.onInterstitialRefresh = function (callback, target) {
    const handler = connector.ads.on("interstitial:refresh", callback);

    addCleaner(target, handler.clear);
};

RewardedAdsManager.prototype.createLoadingOverlay = function () {
    if (this.loadingOverlay) {
        return;
    }

    this.loadingOverlay = true;
    cleverapps.loading.show();
};

RewardedAdsManager.prototype.removeLoadingOverlay = function () {
    if (!this.loadingOverlay) {
        return;
    }

    this.loadingOverlay = false;
    cleverapps.loading.hide();
};

RewardedAdsManager.prototype.createAdOverlay = function (name) {
    cleverapps.audio.mute();

    cleverapps.focusManager.display({
        stack: true,
        focus: "AdOverlay",
        keepControls: true,
        action: function (f) {
            this.rewardOverlay = new RewardedAdOverlay(name);
            cleverapps.Scenes.GetRunningScene().addChild(this.rewardOverlay);

            this.onceRewardOverlayClosed = f;
        }.bind(this)
    });
};

RewardedAdsManager.prototype.removeAdOverlay = function () {
    const isPlatformOff = connector.platform.hasAudioControls && !connector.platform.isAudioEnabled;
    if (!isPlatformOff) {
        cleverapps.audio.unmute();
    }

    if (this.rewardOverlay) {
        this.rewardOverlay.removeFromParent();
        this.rewardOverlay = undefined;
    }

    if (this.onceRewardOverlayClosed) {
        this.onceRewardOverlayClosed();
        this.onceRewardOverlayClosed = undefined;
    }
};

RewardedAdsManager.prototype.adIsRunning = function () {
    return this._isAdRunning;
};

// the ads limit type of the ad the game is showing now, none while no ad of ours runs; lastAdStarter keeps the logging
// name of the last one after the close
RewardedAdsManager.prototype.getRunningAdLimit = function () {
    return this.adIsRunning() ? this.runningAdLimit : undefined;
};

RewardedAdsManager.prototype.getLastAdStarter = function (adLimit) {
    adLimit = adLimit || "none";
    if ([AdsLimits.TYPES.ENERGY_SHORT, AdsLimits.TYPES.ENERGY_1_SHORT, AdsLimits.TYPES.ENERGY_2_SHORT].includes(adLimit)) {
        adLimit = "lives_short";
    }
    if ([AdsLimits.TYPES.ENERGY, AdsLimits.TYPES.ENERGY_1, AdsLimits.TYPES.ENERGY_2].includes(adLimit)) {
        adLimit = AdsLimits.TYPES.LIVES;
    }
    return adLimit;
};

RewardedAdsManager.prototype.removeFrozen = function () {
    cleverapps.dataLoader.remove(DataLoader.TYPES.AD_FROZEN);
};

RewardedAdsManager.prototype.onReward = function () {
    this.baseWatchCounter++;
    this.totalWatchCounter++;

    if (this.baseWatchCounter % 5 === 0) {
        connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.EVERY_5_AD, {
            value: this.baseWatchCounter,
            nickname: "d7a_every5ad,day7_every_ad_5"
        });
    }

    const total = this.totalWatchCounter;

    if ([5, 10, 20, 30].includes(total)) {
        connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.AD_REACH + total, {
            nickname: `d180r_ad_${total},d1r_ad_${total},day1_watch_${total},d7r_ad_${total},day7_watch_${total}`
        });
    }

    connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.AD_IMPRESSION);
    connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.AD_REWARDED);

    cleverapps.dataLoader.save(DataLoader.TYPES.AD_WATCH_COUNTER, this.totalWatchCounter);

    cleverapps.eventBus.trigger("taskEvent", "WATCH_ADS");
};

RewardedAdsManager.prototype.playRewarded = function (adLimit, onSuccessCallback, onCancelCallback, onRetry) {
    onSuccessCallback = onSuccessCallback || function () {};
    onCancelCallback = onCancelCallback || function () {};

    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        onSuccessCallback();
        return;
    }

    if (this.adIsRunning()) {
        onCancelCallback();

        cleverapps.notification.create(Messages.get("AdsRunning"));
        return;
    }

    this.lastAdStarter = this.getLastAdStarter(adLimit);
    this.runningAdLimit = adLimit;

    cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.PLACEMENT_REWARDED, { itemId: this.lastAdStarter });

    this._isAdRunning = true;

    new ActionPlayer([
        function (f) {
            cleverapps.whenGameActive(f);
        },

        function (f) {
            if (cleverapps.vipAdsAdapter.isVIP()) {
                cleverapps.throwAsync("trying to show rewarded for vip user");
            }

            const clicked = Date.now();
            const notLoaded = cleverapps.adsLimits.state(adLimit) === AdsLimits.STATE_NOT_LOADED;
            let error, loadError, start;
            const errorHandler = connector.ads.on("error:showRewarded", (code) => {
                error = code;
            });
            const cachedHandler = connector.ads.on("rewarded:cached", (code) => {
                if (code !== connector.CODE_SUCCEED && code !== "ads_loading_already_loading") {
                    loadError = code;
                }
            });
            const startHandler = connector.ads.on("rewarded:start", () => {
                start = Date.now();
            });

            connector.ads.showRewardedVideoCallback((success) => {
                errorHandler.clear();
                cachedHandler.clear();
                startHandler.clear();

                if (notLoaded) {
                    cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.CLICK_LOAD, {
                        itemId: this.lastAdStarter,
                        plugin: connector.ads.getName(),
                        error: start === undefined ? String(loadError || error || "").replace("ads_loading_", "") : "",
                        value: Math.round(((start || Date.now()) - clicked) / 1000)
                    });
                }

                this.removeFrozen();

                this._isAdRunning = false;

                if (success) {
                    if (connector.ads.isAdBlockEnabled) {
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.AD_BLOCK_REWARDED_SUCCESS);
                    }

                    cleverapps.adsLimits.watch(adLimit);

                    if (cleverapps.adsLimits.state(adLimit) === AdsLimits.STATE_LIMITED) {
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.LIMIT_REACHED, { itemId: this.lastAdStarter });
                    }

                    onSuccessCallback();
                } else {
                    if (connector.ads.isAdBlockEnabled) {
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.AD_BLOCK_REWARDED_FAIL);
                    }

                    onCancelCallback();

                    this.showAdError(this.getErrorWindowKey(error, loadError, start), onRetry);
                }
            });

            f();
        }.bind(this)
    ]).play();
};

RewardedAdsManager.prototype.getErrorWindowKey = function (error, loadError, start) {
    const closedAsError = [connector.ERRORS.SHOW_REWARDED.UNKNOWN, connector.ERRORS.SHOW_REWARDED.NO_ADS].includes(error) && start !== undefined
        && connector.ads.oneOf(connector.AD_MOB, connector.APP_LOVIN, connector.VK, connector.YANDEX_APP_ADS, connector.ARKADIUM);

    if (error === undefined || closedAsError) {
        const watched = start !== undefined && Date.now() - start >= cleverapps.parseInterval(RewardedAdsManager.WATCHED_TIMEOUT);
        return watched ? "closed_late" : "closed_by_user";
    }

    if (error === connector.ERRORS.SHOW_REWARDED.NO_ADS && start === undefined) {
        if (connector.ads.isAdBlockEnabled) {
            return connector.ERRORS.SHOW_REWARDED.AD_BLOCK;
        }
        return RewardedAdsManager.ERROR_WINDOWS[loadError] ? loadError : "ads_loading_failed";
    }

    return error;
};

RewardedAdsManager.prototype.showAdError = function (key, onRetry) {
    const entry = RewardedAdsManager.ERROR_WINDOWS[key];
    if (!entry) {
        return;
    }

    const retry = entry.retry && onRetry;
    let pressed = false;

    cleverapps.focusManager.display({
        focus: "AdError",
        stack: true,
        action: function (f) {
            new AlertWindow({
                icons: "ad_error",
                icon: entry.icon,
                title: entry.title || "AdError.Title",
                text: entry.text,
                button: retry ? "AdError.Retry" : "OK",
                onPressed: () => {
                    pressed = true;
                }
            });
            cleverapps.focusManager.onceNoWindowsListener = function () {
                f();
                if (pressed && retry) {
                    onRetry();
                }
            };
        }
    });
};

RewardedAdsManager.prototype.showPreroll = function (callback) {
    // https://gyazo.com/630bfc6c31bc842ffd2a4b425ec43083 - unstable instant preroll loading time
    if (connector.platform.oneOf(connector.INSTANT, connector.VK)) {
        callback();
        return;
    }

    if (connector.platform.oneOf(connector.TEST) && !cleverapps.gameModes.prerollEnabled) {
        callback();
        return;
    }

    if (connector.ads.oneOf(connector.YANDEX_APP_ADS, connector.APP_LOVIN)) {
        callback();
        return;
    }

    this.showInterstitial(AdsLimits.TYPES.PREROLL, callback);
};

RewardedAdsManager.prototype.showInterstitial = function (adLimit, callback) {
    callback = callback || function () {};

    let placement = adLimit;

    if (typeof adLimit === "object") {
        placement = adLimit.placement;
        adLimit = adLimit.limit;
    }

    if (cleverapps.config.adminMode || cleverapps.config.editorMode || cleverapps.environment.isAtlasAnalyzerScene() || cleverapps.environment.isChatScene()) {
        callback();
        return;
    }

    if (!connector.ads.isInterstitialSupported || this.adIsRunning()) {
        callback();
        return;
    }

    if (cleverapps.noAds && cleverapps.noAds.getState() === NoAds.STATE_ENABLED) {
        callback();
        return;
    }

    const state = cleverapps.adsLimits.state(adLimit);
    const canShow = state === AdsLimits.STATE_READY
        || adLimit === AdsLimits.TYPES.PREROLL && [AdsLimits.STATE_UNAVAILABLE, AdsLimits.STATE_NOT_LOADED].includes(state);

    if (!canShow) {
        if (state === AdsLimits.STATE_LIMITED) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.LIMIT_SKIP, { itemId: this.getLastAdStarter(placement) });
        }

        callback();
        return;
    }

    this.lastAdStarter = this.getLastAdStarter(placement);
    this.runningAdLimit = adLimit;

    this._isAdRunning = true;

    let shown = false;

    new ActionPlayer([
        (f) => {
            cleverapps.whenGameActive(f);
        },

        (f) => {
            if (!connector.ads.isConnected() && adLimit === AdsLimits.TYPES.PREROLL) {
                const listener = connector.ads.once("changeStatus", cleverapps.waitNoMore(5000, () => {
                    listener.clear();
                    f();
                }));
                connector.ads.connect();
            } else {
                f();
            }
        },

        (f) => {
            let startHandler;

            if (connector.ads.oneOf(connector.TEST)) {
                startHandler = connector.ads.on("interstitial:start", cleverapps.accumulate(10, () => {
                    const overlay = document.getElementsByClassName("video-ads-type")[0];
                    if (overlay) {
                        overlay.innerText = `${placement} is playing`;
                    }
                }));
            }

            if (cleverapps.vipAdsAdapter.isVIP()) {
                cleverapps.throwAsync("trying to show interstitial for vip user");
            }

            connector.ads.showInterstitialCallback((success) => {
                this.removeFrozen();

                this._isAdRunning = false;

                shown = success;

                if (success) {
                    cleverapps.adsLimits.watch(adLimit);

                    if (cleverapps.adsLimits.state(adLimit) === AdsLimits.STATE_LIMITED) {
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.LIMIT_REACHED, { itemId: this.lastAdStarter });
                    }
                } else {
                    cleverapps.adsLimits.noHammerDeadNetwork();
                }

                startHandler && startHandler.clear();

                f();
            });
        },

        (f) => {
            const noAdsOffer = shown && adLimit !== AdsLimits.TYPES.PREROLL && cleverapps.offerManager.findOffer({ type: Offers.TYPES.NOADS });

            if (noAdsOffer && noAdsOffer.logic.needToNudge()) {
                cleverapps.focusManager.display({
                    focus: "NoAdsWindowAfterInterstitialForNoOutcomeGames",
                    stack: true,
                    actions: [
                        function (f1) {
                            new NoAdsWindow(noAdsOffer);
                            cleverapps.focusManager.onceNoWindowsListener = f1;
                        },

                        function (f1) {
                            f1();
                            f();
                        }
                    ]
                });
            } else {
                f();
            }
        }
    ]).play(callback);
};
RewardedAdsManager.REWARDED_NOADS_TIMEOUT = "3 minutes";
RewardedAdsManager.WATCHED_TIMEOUT = "30 seconds";
RewardedAdsManager.ERROR_WINDOWS = {
    ads_loading_no_ads: {
        icon: "no_ads",
        title: "AdError.NoAdsTitle",
        text: "AdError.NoAds"
    },
    ads_loading_failed: {
        icon: "failed",
        text: "AdError.Failed"
    },
    not_connected: {
        icon: "failed",
        text: "AdError.Failed"
    },
    ads_loading_timeout: {
        icon: "timeout",
        title: "AdError.TimeoutTitle",
        text: "AdError.Timeout",
        retry: true
    },
    ads_loading_abandoned: {
        icon: "abandoned",
        title: "AdError.AbandonedTitle",
        text: "AdError.Abandoned",
        retry: true
    },
    ads_loading_network_failure: {
        icon: "no_internet",
        title: "AdError.NoInternetTitle",
        text: "AdError.NoInternet",
        retry: true
    },
    rewarded_ad_block: {
        icon: "ad_block",
        title: "AdError.AdBlockTitle",
        text: "AdError.AdBlock"
    },
    ads_loading_ads_frequent_load: {
        icon: "throttled",
        title: "AdError.ThrottledTitle",
        text: "AdError.Throttled"
    },
    ads_loading_ads_too_many_instances: {
        icon: "throttled",
        title: "AdError.ThrottledTitle",
        text: "AdError.Throttled"
    },
    rewarded_throttled: {
        icon: "throttled",
        title: "AdError.ThrottledTitle",
        text: "AdError.Throttled"
    },
    rewarded_not_found: {
        icon: "not_found",
        title: "AdError.NotFoundTitle",
        text: "AdError.NotFound",
        retry: true
    },
    rewarded_expired_error: {
        icon: "expired",
        title: "AdError.ExpiredTitle",
        text: "AdError.Expired",
        retry: true
    },
    rewarded_unknown_error: {
        icon: "unknown",
        title: "AdError.UnknownTitle",
        text: "AdError.Unknown"
    },
    interstitial_unknown_error: {
        icon: "unknown",
        title: "AdError.UnknownTitle",
        text: "AdError.Unknown"
    },
    closed_by_user: {
        icon: "closed",
        title: "AdError.ClosedTitle",
        text: "AdError.Closed"
    },
    closed_late: {
        icon: "closed_late",
        title: "AdError.ClosedTitle",
        text: "AdError.ClosedLate"
    }
};
RewardedAdsManager.REWARDED = "rewarded";
RewardedAdsManager.INTERSTITIAL = "interstitial";
RewardedAdsManager.PREROL_SHOWING = "showing";
RewardedAdsManager.PREROL_SHOWN = "shown";